export type MediaUrlVariant = "original" | "preview" | "thumbnail";

export function getMediaVariantUrl(
  originalUrl: string,
  variant: MediaUrlVariant,
): string {
  if (!originalUrl || variant === "original") return originalUrl;

  try {
    const url = new URL(originalUrl);
    const variantPath = url.pathname.replace(/(\.[^./]+)$/, `-${variant}$1`);

    if (variantPath === url.pathname) return originalUrl;

    url.pathname = variantPath;

    return url.toString();
  } catch {
    return originalUrl;
  }
}

export function getMediaVariantCandidates(
  originalUrl: string,
  preferredVariant: MediaUrlVariant,
): string[] {
  const variants: MediaUrlVariant[] =
    preferredVariant === "thumbnail"
      ? ["thumbnail", "preview", "original"]
      : preferredVariant === "preview"
        ? ["preview", "original"]
        : ["original"];

  return [
    ...new Set(
      variants.map((variant) => getMediaVariantUrl(originalUrl, variant)),
    ),
  ];
}
